import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'odq-section-header',
    templateUrl: './section-header.component.html',
    styleUrls: ['./section-header.component.scss'],
    standalone: false
})
export class SectionHeaderComponent implements OnChanges {

  @Input() sectionName: string;
  @Input() title: string;
  safeTitle: SafeHtml;

  constructor(private sanitized: DomSanitizer) { }

  ngOnChanges(changes: SimpleChanges) {
    this.safeTitle = this.sanitized.bypassSecurityTrustHtml(changes.title.currentValue);
  }

}
